export default "__VITE_ASSET__DHlxjAmf__"